import { useMemo } from 'react';
import { useWishes } from '../../../../../redux/reducer/content';
import { giftNoticeWishContent } from '../../../../../constants/copyright-modals';
import { cloneDeep } from 'lodash';
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle';

export default function useGiftWishesModal() {
  const {
    images: wishesImages,
    texts: wishesTexts,
    donatedWishes: { list: wishesList },
  } = useWishes();

  const gameTamagotchiPromo8March = useFeatureToggle('gameTamagotchiPromo8March');

  return useMemo(() => {
    const [wish] = wishesList ?? [];

    if (!gameTamagotchiPromo8March || !wish || !wishesImages?.length || !wishesTexts?.length) return [];

    const imageData = wishesImages?.find(({ id }) => wish?.wishId === id);
    const elf = wish?.elf ?? 1;
    const images = [imageData?.[`elf${elf}`]];

    const name = wish?.authorUsername;
    const viewName = wish?.name;
    const uid = wish?.author;
    const text = wishesTexts?.find(({ id }) => id === wish?.wishTextId)?.value;
    const {
      buttons: [openWishCard, closeModal],
      ...otherProps
    } = giftNoticeWishContent;
    const totalOpenWishCardButton = cloneDeep(openWishCard);
    totalOpenWishCardButton.attr.modalData.data.props = {
      images,
      title: '8march.congratulate8march',
      name: viewName,
      is_black_text: imageData?.is_black_text,
      text,
    };

    return {
      id: `giftWishCard2025`,
      type: 'giftNotice',
      props: { ...otherProps, buttons: [totalOpenWishCardButton, closeModal], images, name, uid },
    };
  }, [wishesList, wishesImages, wishesTexts]);
}
